import { Injectable, Pipe, PipeTransform } from '@angular/core'
import { isNullOrUndefinedString } from '@services/core.utilities'

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'numberformat',
})
export class NumberFormatPipe implements PipeTransform {
  transform(value: string | null): string {
    var val_trans = ''
    if (!isNullOrUndefinedString(value) && value) {
      val_trans = value.split(',').join(' ')
    }
    return val_trans
  }
}
